<template>
  <div class="privacy">

    <div class="header">
			<div class="swift-logo">
				<img src="@/assets/swift.png" alt="">
			</div>
	  </div>

    <div class="content">
      <h1>
        杰信云隐私政策
      </h1>
      <div class="title-date">
        生效日期:
      </div>
      <p>
        特别说明：
      </p>
      <p class="indent">
        杰信软件科技（苏州）有限公司（以下统称为“我们”或“杰信云”，注册地址【        】）一向高度重视个人信息的保护。在您使用杰信云提供的产品和服务（以下统称为 “杰信云服务” ）时，您作为我们的客户，我们可能会收集和使用您的相关个人信息；同时， 您作为控制者决定您的产品和服务的最终用户（以下简称为“最终用户” ）个人信息的处理目的和方式，我们在为您提供杰信云服务过程中作为数据处理者，接受您的委托并根据您指示收集和使用最终用户的相关个人信息 。我们希望通过本《杰信云隐私政策》（以下简称为 “本政策” ）向您和最终用户清晰地介绍我们对您及最终用户的个人信息的处理方式，以便更好地保障您和最终用户的权益。
      </p>
      <p>
        本政策适用于杰信云提供的各项服务，包括但不限于我们提供的网站、 SDK、API 、插件、组件、代码、工具以及不断创新研发的产品及服务。因此， 在使用杰信云服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后使用我们的相关产品或服务；在最终用户使用您的产品和服务前，请您务必制定、发布您的隐私类政策文件并获得您的最终用户同意以使杰信云有权收集和使用其个人信息提供相应服务，且该政策文件应包含本政策关于最终用户个人信息的处理规则以及不低于本政策规定的个人信息保护标准 。
      </p>
      <p>
        如果您不同意本政策的内容或者您的最终用户不同意杰信云根据本政策收集并使用其个人信息提供相应服务，您应立即停止使用杰信云服务。您使用或继续使用杰信云服务，都表示您和最终用户同意我们按照本政策（包括更新版本）收集、使用、储存、分享、转让和披露您及最终用户的个人信息；如果因您未事先获得最终用户同意而引起的相关责任由您完全承担。
      </p>
      <p>
        在阅读完本政策后，如您和最终用户对本政策或与本政策相关的事宜有任何问题，可通过本政策 “如何联系我们” 章节 所列的反馈渠道联系我们，我们会尽快作出解答。
      </p>
      <p>
        本政策将帮助您了解以下内容：
      </p>
      <p>
        一、我们如何收集和使用您及最终用户的个人信息</br>
        二、最终用户个人信息的授权与使用</br>
        三、我们如何共享、转让、公开披露您及最终用户的个人信息</br>
        四、我们如何存储您及最终用户的个人信息</br>
        五、如何保护您及最终用户的个人信息</br>
        六、我们如何管理您及最终用户的个人信息</br>
        七、我们如何处理未成年人的信息</br>
        八、修订和通知</br>
        九、如何联系我们
      </p>
      <p>
        企业用户：指注册、登录、使用杰信saas产品及服务并获得管理权限的个人或组织，包括但不限于法人、政府机构、其他组织、合伙或个体工商户等（下称“企业用户”）；企业用户可以通过杰信saas创建其工作平台（指由企业用户创建并管理的，可以多人加入共同使用saas服务的虚拟工作空间），邀请并授权个人用户加入其工作平台成为其最终用户。
      </p>
      <p>
        企业用户管理员：指经企业用户指定，拥有企业用户管理后台系统操作权限的个人；企业用户管理员可以为一人或多人。
      </p>
      <p>
        个人用户/最终用户：指被企业用户邀请加入企业工作平台，注册使用saas的个人用户，以下称“你”或“最终用户”。当企业用户邀请你作为最终用户接入其工作平台，你会收到邀请并可以选择是否加入该企业用户。
      </p>
      <p>
        个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
      </p>
      <p>
        个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括身份证件号码、个人生物识别信息、通信记录和内容、财产信息、行踪轨迹、健康生理信息、交易信息等。
      </p>
      <p>
        企业控制的数据：指企业用户和该企业用户的最终用户使用saas过程中提交或产生的信息和数据，包括企业用户提交或要求最终用户提供的信息、企业用户分配给最终用户的信息，以及为完成工作需求、满足企业日常管理需求最终用户提交给企业用户的信息。
      </p>
      <p>
        匿名化处理：指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。
      </p>
      <p>
        一、我们如何收集和使用您及最终用户的个人信息
      </p>
      <p>
        我们会依据相关法律法规，遵循正当、合法、必要的原则，出于本政策所述的目的，收集和使用您在使用杰信云服务过程中主动提供的、因您使用杰信云服务而产生的以及因您的最终用户使用您的服务和产品而产生的您和 /或最终用户的个人信息。
      </p>
      <p>
        请您理解，由于商业策略的变化及法律法规的相关要求，杰信云服务的业务功能也可能进行更迭和发展。 如果我们要将您和/ 或最终用户的个人信息用于本政策未载明的其他用途或额外收集未提及的其他个人信息，我们会通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。 在此过程中，您可通过本政策 “如何联系我们” 章节所列的反馈渠道联系我们，我们会尽快作出解答。
      </p>
      <p>1、您作为我们的客户的个人信息</p>
      <p>1.1 为完成杰信云服务账户的注册、登录、管理和实名认证等必要活动，您可能需要提交真实、合法、有效的信息 。您可能需要提交的信息包括：您的 企业基本信息（单位名称、营业执照、统一社会信用代码）、您的法定代表人姓名、您的经办人信息（包括姓名、手机号码、邮箱地址、身份证号码）、您的经办人生物识别信息（动态或静态的面部特征）以及您的银行账户信息（包括开户银行、开户账号、开户名称、注册地址及注册电话）；</p>
      <p>为实现实名认证的目的，您同意并授权我们可能自行或委托第三方向有关身份认证机构（如个人征信机构、政府部门等）提供、查询、核对您的前述信息。</p>
      <p>1.2 为保障杰信云服务的正常运行，保护您或第三方的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或杰信云服务相关协议规则的情况 ，我们在您使用杰信云服务期间，将记录并保存您 登录和使用杰信云服务的详细情况，并作为网络日志进行保存，包括Internet协议(IP)地址、Internet服务提供商（ISP）、浏览器类型、访问日期和时间、软硬件特征信息及网页浏览记录。</p>
      <p>我们收集这些信息是为了向您更好提供服务，为了实现这一目的，我们还将把您的信息用于下列用途： （1）联系您解决问题；（2）改进我们的服务质量；（3）其他经您许可的其他用途。</p>
      <p>2、您的最终用户的个人信息</p>
      <p>基于您的委托和指示，为实现杰信云服务的基本业务功能，我们可能需要收集、使用您的最终用户的相关个人信息。根据您选择的杰信云服务不同，我们将收集的最终用户个人信息也将不同。以下将详细列出我们的基本业务功能及为实现该功能所必需的信息类型，这些个人信息的收集、使用需要您获得最终用户的同意。</p>
      <p>这里需要根据公司要求添加相应的信息或修改相关信息</p>
      <p>2.1向您提供本服务。通过收集您的帐号信息（帐号、手机号、邮箱地址）、订单信息（如有）来核实您的本服务的合法性、有效性并提供本服务相关服务及相关技术支持。</p>
      <p>2.2相关云服务的使用。杰信云目前所运营的需要在云端实现的功能均以您在联网状态下、登录帐号后将相关文档、图片、照片、语音、信息等材料上传（包括手动上传和自动漫游）至云端为前提，杰信云收集您上传至云端的文档名称、内容、文档属性（包括但不限于文档类型、大小、页数等）、上传、启动云文档的频率、使用云文档的时长等信息是为您提供相关云服务所必需的。</p>
      <p>2.3保证安全。为提高您使用本服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，杰信云可能会通过了解您的浏览信息、订单信息、软件信息、设备信息等手段来判断您的帐号风险，并可能会记录一些杰信云认为有风险的链接（“URL”）。杰信云也会收集您的设备信息、日志信息对于您在使用本服务时的问题进行分析、统计流量并排查可能存在的风险、在您选择向杰信云发送异常信息时予以排查。</p>
      <p>2.4客服与售后。如您在使用本服务寻求服务支持时，杰信云会根据您的帐号信息、订单信息核对您的身份及购买的相关产品或服务（如有），并根据您设备信息以及您发送的邮件内容、截图、文档、或与杰信云客服人员的电话对话内容帮您查找原因、解决问题；杰信云可能会不时使用您的帐号信息（如手机号、邮箱地址）来发送重要通知，例如有关兑换物的通知和相关协议条款、条件和政策变更；如果您通过本服务的相关网站页面、微信公众号等参与了抽奖、比赛或类似的促销，杰信云可能会要求您提供身份证号来核实您的真实身份；杰信云还会收集您参与问卷调查时向杰信云提交的问卷答复信息、您通过拨打客服热线、发送电子邮件、论坛发帖、公众号留言等各种方式提交咨询时所提供的联系人姓名、公司名称、联系电话、邮箱地址及您的咨询内容。</p>
      <p>2.5支付结算：在您下单购买本服务的任意服务（如有）后，您可以选择与杰信云合作的第三方支付机构（如支付宝、微信支付等支付通道，以下称“支付机构”）所提供的支付服务，杰信云需要将您的订单号、交易金额、交易内容的信息提供给支付机构以确认您的支付指令并完成支付。如您申请发票，还需提供以下信息：发票抬头、纳税人识别号、收票人邮箱地址，以及您根据您的开票需求提供的更多信息，如购买方信息。</p>
      <p>2.6大数据分析。杰信云会将所收集的您的个人信息用于大数据分析。</p>
      <p>2.7遵从和执行适用的法律要求及相关的行业标准。</p>
      <p>3 、请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。</p>
      <p>4、征得授权同意的例外</p>
      <p>根据相关法律法规规定，以下情形中收集您及最终用户的信息无需征得您的同意：</p>
      <p>（1）与国家安全、国防安全直接相关的；</p>
      <p>（2 ）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（3 ）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>（4 ）出于维护您、最终用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>（5 ）所收集的个人信息是您及最终用户自行向社会公众公开的；</p>
      <p>（6 ）根据您的要求签订和履行合同所必需的，但前提是您已获得最终用户的同意；</p>
      <p>（7 ）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>（8 ）维护杰信云服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
      <p>（9）开展合法的新闻报道所必需的；</p>
      <p>（10 ）出于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>
      <p>（11）法律法规规定的其他情形。</p>
      <p>二、最终用户的个人信息授权与使用</p>
      <p>您作为最终用户的个人信息控制者，我们接受您的委托并根据您指示为您提供数据处理服务，但无法控制您如何使用最终用户的个人信息。您应当采用符合适用的法律和道德义务的方式收集、使用并授权我们收集、使用您的最终用户的个人信息。</p>
      <p>如果您接受本政策并在您的产品和服务中使用杰信云服务，您需保证您已经遵守并将持续遵守适用的法律、法规和监管要求和本政策的规定，包括但不限于：</p>
      <p>1 、将遵守向最终用户收集信息有关的所有适用的法律、法规和监管要求；</p>
      <p>2 、必须向最终用户披露自身的产品和服务中使用了杰信云服务，以及我们如何收集和使用最终用户个人信息的规则并获得最终用户充分、必要且明确的授权同意，允许我们在符合相关法律法规的前提下可将收集的信息用于本政策列明的服务用途 。为履行上述义务，您应当制定、发布不低于本政策规定的个人信息保护标准的隐私类政策文件。我们也强烈建议您在您的隐私类政策文件中嵌入本政策的链接并增加类似条款： “ 我们的产品或服务可能包括第三方的产品或服务，也可能收集并使用您的个人信息。例如，我们为实现【 】服务集成杰信云SDK ，杰信云将作为数据处理者，按照本公司的指示收集处理您的数据，杰信云将按照《杰信云隐私政策》所述收集、使用并保护您的个人信息》 ”；</p>
      <p>3 、已经向最终用户提供易于操作的权利实现和信息管理机制，说明用户如何行使选择权、如何访问、更正其个人信息、行使删除权、更改其授权同意的范围等操作。</p>
      <p>如果您无法满足前述条件或者您的最终用户不同意杰信云根据本政策收集、使用其个人信息的，则您不应当继续使用杰信云服务；您的继续使用行为，视为您已经同意并向我们保证您所有的最终用户已同意我们有权收集和使用其个人信息提供相应服务。无论如何，如因您未能事先获得最终用户同意以使我们有权收集并使用其个人信息提供服务而引起的一切责任由您承担，如给我们造成任何损失，您应予以全部赔偿。</p>
      <p>三、我们如何共享、转让、公开披露您及最终用户的个人信息</p>
      <p>1、共享</p>
      <p>杰信云不会与杰信云以外的任何公司、组织和个人分享您的个人信息。除下列情况外，我们不会与任何第三方共享您最终用户的个人信息：</p>
      <p>（1 ） 获得您的同意或您委托我们向您指定的第三方转让最终用户的个人信息，但前提是您已获得最终用户的同意 ；</p>
      <p>（2 ）根据法律法规的规定、强制性的行政执法或司法要求；</p>
      <p>（3 ）只有共享您最终用户的信息，才能提供服务，或处理您最终用户与他人的纠纷或争议。我们会与共享的合作伙伴签署严格的保密协定，要求他们按照本政策以及采取严格的数据安全措施来处理和使用数据。</p>
      <p>2、转让</p>
      <p>我们仅会在以下情况，转让您或最终用户的个人信息：</p>
      <p>（1 ） 获得您的同意或您委托我们向您指定的第三方转让最终用户的个人信息，但前提是您已获得最终用户的同意；</p>
      <p>（2 ）随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您及最终用户的个人信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您及最终用户个人信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新征求授权同意。</p>
      <p>3、公开披露</p>
      <p>我们仅会在以下情况，公开披露您或最终用户的个人信息：</p>
      <p>（1 ） 获得您的同意或您委托我们披露最终用户的个人信息，但前提是您已获得最终用户的同意；</p>
      <p>（2 ）根据法律法规的规定、强制性的行政执法或司法要求所必须提供相关信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您或最终用户的个人信息。</p>
      <p>四、我们如何存储您及最终用户的个人信息</p>
      <p>1、存储时限</p>
      <p>除法律法规或监管部门另有规定，我们仅在本政策所述目的所必需期间且最短时限内储存您及最终用户的个人信息 。如我们终止服务或运营，我们将及时停止继续收集个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对相关个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</p>
      <p>2、存储地域</p>
      <p>原则上，我们仅在中国境内存储您及最终用户的个人信息。但在以下情况，我们可能向中国境外提供您及最终用户的 个人信息，或者在中国境外存储您及最终用户的个人信息：</p>
      <p>（1）法律法规有明确规定；</p>
      <p>（2）获得您的同意，但前提是您确保已获得最终用户的同意。</p>
      <p>我们请您特别注意：不同国家或地区对于个人信息的收集、存储、使用、共享等各有其监管要求， 您应主动遵守各个国家或地区的法律法规和监管要求。 为了避免您由于不了解您的最终用户所在国或所在地区关于个人信息保护相关法律法规而触犯当地的监管规定， 我们强烈建议您仅在中国境内使用杰信云服务。如您将杰信云服务应用于中国境外的，您应当遵循当地有关个人信息跨境传输转移的法律要求，以保证在中国境内存储个人信息符合当地的监管要求。 特别是， 当跨境传输涉及到俄罗斯、印度、欧盟、美国等国家或地区时，请注意这些国家和地区的个人信息监管规定 。您同意，跨境传输产生的风险和责任将由您自行承担，如导致我们发生任何形式的损失，您负责给予我们全额赔偿。</p>
      <p>五、我们如何保护您及最终用户的个人信息</p>
      <p>我们非常重视信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您及最终用户的个人信息：</p>
      <p>1 、我们会采用符合业界标准的安全技术措施，包括采取加密等技术对您及最终用户的个人信息进行加密保存，并通过隔离技术进行隔离，以防止您及最终用户的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。</p>
      <p>2 、我们有行业先进的以个人信息为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理等方面多维度提升整个系统的安全性。我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
      <p>3 、我们仅允许有必要知晓这些信息的人员访问您及最终用户的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您及最终用户的个人信息的所有人员履行相应的保密义务。</p>
      <p>4、 我们重视信息安全合规工作，并通过众多国际和国内的 安全认证，如 ISO27001 信息安全管理体系认证、信息系统安全等级保护认证等，以业界先进的解决方案充分保障您及最终用户的信息安全。</p>
      <p>5 、为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</p>
      <p>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，按照《国家网络安全事件应急预案》等有关规定及时上报，并以发送邮件、推送通知、公告等形式告知您相关情况，并向您给出安全建议。</p>
      <p>您需要了解，您使用杰信云服务所用的系统和通讯网络等，有可能因我们可控范围外的情况而发生问题。 为更有效的保障您及最终用户的信息安全，我们也希望您能够加强自我保护， 如果因您的物理、技术、或管理防护设施遭到破坏，导致您及最终用户的个人信息被非授权访问、公开披露、篡改、或毁坏，由此产生的风险和责任将由您自行承担，我们将不承担责任。</p>
      <p>六、如何管理您及最终用户的个人信息</p>
      <p>1、管理您的个人信息</p>
      <p>（1）访问、更新和删除</p>
      <p>我们鼓励您更新和修改您的个人信息以使其更准确有效。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和删除自身的个人信息。</p>
      <p>如您想查询、修改或删除您的部分个人信息，您可以选择联系我们的客服渠道（     ）或者通过本政策“ 如何联系我们 ”章节所列的反馈渠道联系我们以行使您的权利，但法律法规另有规定的除外 。 在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。</p>
      <p>（2）账号注销</p>
      <p>我们向您提供帐号注销的途径。 在符合我们的服务条款约定条件及相关法律法规规定的情况下，您可以选择联系我们的客服渠道（      ）或者通过本政策“ 如何联系我们”章节所列的反馈渠道联系我们以注销您的杰信云账户 。在您注销账号时，我们可能会要求您进行身份验证，以保障信息安全。</p>
      <p>（3）改变您授权同意的范围</p>
      <p>您总是可以选择是否向我们披露个人信息。有些个人信息是使用杰信云服务所必需的，对于额外收集的个人信息，您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。</p>
      <p>（4）约束信息系统自动决策</p>
      <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。</p>
      <p>（5）删除、注销及撤回授权可能产生的影响</p>
      <p>当您删除某项个人信息或撤回某项授权后，我们将无法继续为您提供所对应的服务，也不再处理您相应的个人信息；当您注销账号后，我们将停止为您提供全部杰信云服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。</p>
      <p>无论如何，您做出的上述决定，不会影响此前基于您的授权而开展的个人信息处理，由此造成您无法继续使用全部或部分杰信云服务的，相应后果和损失由您自行承担，我们将依据我们的服务条款和相应规则做出处理。</p>
      <p>2、管理最终用户的个人信息</p>
      <p>鉴于您的最终用户不是杰信云的直接客户， 您应当遵循适用的法律、法规和监管要求和本政策的规定，为最终用户提供易于操作的方式以响应最终用户访问、更新、删除其个人信息、注销账号、更改其授权同意的范围等请求 。</p>
      <p>如果您在操作过程中有疑惑或困难且必需我们配合才能完成的， 您可以选择联系我们的客服渠道（   ）或者通过本政策“ 如何联系我们”章节所列的反馈渠道联系我们以行使您的权利 ，我们将根据您的委托、法律法规和本政策的规定进行处理。 如果最终用户选择直接向杰信云提出相关请求的，为了保护您、最终用户以及他人的合法权益，我们会要求该用户进行身份的验证。在向您进行核实后，我们有权根据法律法规以及本政策的规定处理该用户的相关请求 。</p>
      <p>无论如何，作为最终用户的数据控制者，您都应当承担最终用户的请求响应和处理，如因您的原因给我们造成任何损失，您应予以全部赔偿。</p>
      <p>3、响应您及最终用户的上述请求</p>
      <p>为保障安全，您及最终用户可能需要提供书面请求，或以其他方式证明身份。我们可能会先要求您及最终用户验证自己的身份，然后再处理请求。对于您及最终用户合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些与我们无关、无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
      <p>在以下情形中，我们将无法响应您及最终用户的请求：</p>
      <p>（1）与我们履行法律法规规定的义务相关的；</p>
      <p>（2）与国家安全、国防安全直接相关的；</p>
      <p>（3 ）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（4 ）与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
      <p>（5 ）我们有充分证据表明您或最终用户存在主观恶意或滥用权利的；</p>
      <p>（6 ）出于维护您、最终用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>（7 ）响应您及最终用户的请求将导致您、最终用户或其他个人、组织的合法权益受到严重损害的；</p>
      <p>（8）涉及商业秘密的。</p>
      <p>七 、 我们如何处理未成年人的信息</p>
      <p>我们非常重视未成年人的个人信息保护，如您是未成年人，请勿注册成为我们的用户并使用杰信云服务。 如您的产品和/ 或服务涉及未成年用户，请您务必遵守可适用的法律、法规和监管要求，并采取必要的措施确保未成年人的注册、使用与未成年用户个人信息的收集、使用均已获得其监护人的同意，同时，您应在您的隐私类政策文件中履行相应的告知义务。</p>
      <p>受制于现有技术和业务模式，我们很难主动识别未成年人的信息。如果我们在不知情的情况下收集了未成年人的个人信息或在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，监护人可通知我们予以删除，如我们自己发现前述情形，我们也会主动予以删除而无需征得您的同意，除非法律要求我们保留此类资料。</p>
      <p>八、修订和通知</p>
      <p>为了给您提供更好的服务，我们可能会根据杰信云服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。我们会在本页面上发布对本政策所作的任何变更。对于重大变更，我们还会提供更为显著的通知（如网站公告、推送通知、弹窗提示），本政策所指的重大变更包括但不限于：</p>
      <p>1 、杰信云服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
      <p>2 、我们在所有权结构方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
      <p>3 、个人信息共享、转让或公开披露的主要对象发生重大变化；</p>
      <p>4 、您及最终用户参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
      <p>5 、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生重大变化；</p>
      <p>6 、其他重要的或可能严重影响您及最终用户的个人权益的情况发生。</p>
      <p>您如果不同意该等变更，您将无法继续使用杰信云服务；如您仍继续使用杰信云服务的，即表示您已充分阅读、理解并同意受经修订的本政策的约束。我们的任何修改都会将您及最终用户的满意度置于首位。我们鼓励您在每次使用服务时都查阅我们的隐私政策。</p>
      <p>我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
      <p>九、如何联系我们</p>
      <p>我们设立了个人信息保护专职部门，将按照本政策保护您及最终用户的个人信息。如您和最终用户有关杰信云服务信息安全的投诉和举报，或对本政策、隐私措施、您及最终用户的个人信息的相关事宜有任何问题、意见或建议，请与杰信云的个人信息保护工作人员联系，可发送邮件至        ，也可以写信至以下地址：              ；邮编：         。</p>
      <p>一般情况下，我们将在收到相关问题、意见或建议，并验证身份后的十五个工作日内予以回复。</p>
    </div>
  </div>
</template>

<style scoped>
  .privacy {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .header {
    width: 100%;
    height: 100px;
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    background: #fff;
  }
  .swift-logo {
    width: 230px;
    margin-left: 30px;
    margin-top: 10px;
    overflow: hidden;
  }
  .swift-logo img{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .content {
    width: 1024px;
    overflow: hidden;
    margin: 0 auto;
  }
  .content h1 {
    font-size: 20px;
    text-align: center;
  }
  .content .indent {
    text-indent:2em;
  }
  .title-date {
    text-align: right;
    font-weight: bold;
  }
</style>

<script>
import axios from "axios";

export default {
  data() {
    return {
      
    };
  },
  components: {

  },

  methods: {
    
  },
  created() {

  },
  watch: {

  },
};
</script>



